/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ResponseWorldStreetsSettingsResource', 'model/WorldStreetsSettingsResource'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ResponseWorldStreetsSettingsResource'), require('../model/WorldStreetsSettingsResource'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.WorldStreetsSettingsApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.ResponseWorldStreetsSettingsResource, root.GisServerApis.WorldStreetsSettingsResource);
  }
}(this, function(ApiClient, ResponseWorldStreetsSettingsResource, WorldStreetsSettingsResource) {
  'use strict';

  /**
   * WorldStreetsSettings service.
   * @module api/WorldStreetsSettingsApi
   * @version 1.0.0
   */

  /**
   * Constructs a new WorldStreetsSettingsApi. 
   * @alias module:api/WorldStreetsSettingsApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getSettingsV1 operation.
     * @callback module:api/WorldStreetsSettingsApi~getSettingsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseWorldStreetsSettingsResource} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the current configuration settings for the World Streets service.
     * @param {module:api/WorldStreetsSettingsApi~getSettingsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseWorldStreetsSettingsResource}
     */
    this.getSettingsV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseWorldStreetsSettingsResource;

      return this.apiClient.callApi(
        '/api/v1/world-streets/settings', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateSettingsV1 operation.
     * @callback module:api/WorldStreetsSettingsApi~updateSettingsV1Callback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the configuration settings for the World Streets service.
     * @param {Object} opts Optional parameters
     * @param {module:model/WorldStreetsSettingsResource} opts.item 
     * @param {module:api/WorldStreetsSettingsApi~updateSettingsV1Callback} callback The callback function, accepting three arguments: error, data, response
     */
    this.updateSettingsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['item'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;

      return this.apiClient.callApi(
        '/api/v1/world-streets/settings', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

